import { getToken, usersOptions } from "helper/common";
import {
    CLEAR_CUSTOMER_DETAILS,
    CLEAR_CUSTOMER_LIST,
    SET_CUSTOMER_DETAILS,
    SET_CUSTOMER_LIST,
    CUSTOMER_CREATE_DIALOG_CLOSE,
    CUSTOMER_CREATE_DIALOG_OPEN,
    CUSTOMER_CREATE_ERROR,
    CUSTOMER_CREATE_ERROR_CLEAR,
    CUSTOMER_CREATE_PENDING,
    CUSTOMER_DETAILS_ERROR,
    CUSTOMER_DETAILS_ERROR_CLEAR,
    CUSTOMER_DETAILS_PENDING,
    CUSTOMER_EDIT_DIALOG_CLOSE,
    CUSTOMER_EDIT_DIALOG_OPEN,
    CUSTOMER_EDIT_ERROR,
    CUSTOMER_EDIT_ERROR_CLEAR,
    CUSTOMER_EDIT_PENDING,
    CUSTOMER_LIST_ERROR,
    CUSTOMER_LIST_ERROR_CLEAR,
    CUSTOMER_LIST_PENDING,
    CUSTOMER_FILTER_DIALOG_OPEN,
    CUSTOMER_FILTER_DIALOG_CLOSE,
    SET_CUSTOMER_FILTER_DATA,
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { trimmedValues } from "helper/trim";
import { encodeObjectValues } from "helper/encodeData";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setCustomerList = (customerList) => ({
    type: SET_CUSTOMER_LIST,
    payload: { customerList }
});

export const clearCustomerList = () => ({
    type: CLEAR_CUSTOMER_LIST,
});

export const customerListPending = () => ({
    type: CUSTOMER_LIST_PENDING
});

export const customerListError = (errorMessage) => ({
    type: CUSTOMER_LIST_ERROR,
    payload: { errorMessage }
});

export const customerListErrorClear = () => ({
    type: CUSTOMER_LIST_ERROR_CLEAR
});

export const getCustomerList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter })
    dispatch(customerListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.customers.getCustomerList(accessToken, page, pageSize, sortOrder, sortDirection, encodeFilters)
            .then((customerList) => {
                dispatch(setCustomerList(customerList));
                dispatch(customerListErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(customerListError(message));
                }
                else {
                    dispatch(customerListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openCustomerFilterDialog = () => ({
    type: CUSTOMER_FILTER_DIALOG_OPEN
});

export const closeCustomerFilterDialog = () => ({
    type: CUSTOMER_FILTER_DIALOG_CLOSE
});

export const setCustomerFilteredData = (filter) => ({
    type: SET_CUSTOMER_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| DETAILS ||---------------------------------------------------------------
export const setCustomerDetails = (customerDetails) => ({
    type: SET_CUSTOMER_DETAILS,
    payload: { customerDetails }
});

export const clearCustomerDetails = () => ({
    type: CLEAR_CUSTOMER_DETAILS,
});

export const customerDetailsPending = () => ({
    type: CUSTOMER_DETAILS_PENDING
});

export const customerDetailsError = (errorMessage) => ({
    type: CUSTOMER_DETAILS_ERROR,
    payload: { errorMessage }
});

export const customerDetailsErrorClear = () => ({
    type: CUSTOMER_DETAILS_ERROR_CLEAR
});

export const getCustomerDetails = (id) => (dispatch) => {
    dispatch(customerDetailsPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.customers.getCustomerDetails(accessToken, id)
            .then((customerDetails) => {
                dispatch(setCustomerDetails(customerDetails));
                dispatch(customerDetailsErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(customerDetailsError(message));
                }
                else {
                    dispatch(customerDetailsError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| CREATE ||---------------------------------------------------------------
export const openCustomerCreateDialog = () => ({
    type: CUSTOMER_CREATE_DIALOG_OPEN
});

export const closeCustomerCreateDialog = () => ({
    type: CUSTOMER_CREATE_DIALOG_CLOSE
});

export const customerCreatePending = () => ({
    type: CUSTOMER_CREATE_PENDING
});

export const customerCreateError = (errorMessage) => ({
    type: CUSTOMER_CREATE_ERROR,
    payload: { errorMessage }
});

export const customerCreateErrorClear = () => ({
    type: CUSTOMER_CREATE_ERROR_CLEAR
});

export const customerCreate = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(customerCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.customers.customerCreate(accessToken, dataToSend)
            .then(() => {
                dispatch(getCustomerList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(customerCreateErrorClear());
                dispatch(closeCustomerCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Customer successfully created.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(customerCreateError(message));
                }
                else {
                    dispatch(customerCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

export const getUsersOption = (search, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.customers.getUsersOption(accessToken, search, page, pageSize)
            .then((userList) => {
                const { value } = userList || [];
                const options = usersOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openCustomerEditDialog = () => ({
    type: CUSTOMER_EDIT_DIALOG_OPEN
});

export const closeCustomerEditDialog = () => ({
    type: CUSTOMER_EDIT_DIALOG_CLOSE
});

export const customerEditPending = () => ({
    type: CUSTOMER_EDIT_PENDING
});

export const customerEditError = (errorMessage) => ({
    type: CUSTOMER_EDIT_ERROR,
    payload: { errorMessage }
});

export const customerEditErrorClear = () => ({
    type: CUSTOMER_EDIT_ERROR_CLEAR
});

export const customerEdit = (formData) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(customerEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.customers.customerEdit(accessToken, dataToSend)
            .then(() => {
                dispatch(getCustomerDetails(formData?.id));
                dispatch(customerEditErrorClear());
                dispatch(closeCustomerEditDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Customer details successfully updated.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(customerEditError(message));
                }
                else {
                    dispatch(customerEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}